import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const DisableAlert = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.625 1.63021C8.625 1.28215 8.34518 1 8 1C7.65482 1 7.375 1.28215 7.375 1.63021V2.36297C6.27938 2.50213 5.25361 3.0044 4.46447 3.80011C3.52678 4.74561 3 6.02797 3 7.36509V9.86491C3 10.213 3.27982 10.4951 3.625 10.4951C3.97018 10.4951 4.25 10.213 4.25 9.86491V7.36509C4.25 6.36225 4.64509 5.40048 5.34835 4.69136C6.05161 3.98224 7.00544 3.58386 8 3.58386L8.00182 3.58386C8.52607 3.58232 9.04461 3.69375 9.52269 3.91068C9.83746 4.05351 10.2075 3.91199 10.3491 3.5946C10.4908 3.2772 10.3504 2.90411 10.0356 2.76128C9.58671 2.55758 9.11116 2.42332 8.625 2.36194V1.63021Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5669 2.06687C14.811 2.31298 14.811 2.71201 14.5669 2.95812L12.4602 5.08237C12.8148 5.78756 13.0008 6.56938 13 7.36483C13 9.39845 13.2152 10.5423 13.4082 11.1555C13.5042 11.4603 13.5927 11.6275 13.6417 11.7058C13.6591 11.7336 13.6715 11.7502 13.6775 11.7577C13.857 11.9272 13.9222 12.1891 13.8398 12.426C13.7519 12.6786 13.5154 12.8476 13.25 12.8476H4.75913L2.31694 15.3101C2.07286 15.5563 1.67714 15.5563 1.43306 15.3101C1.18898 15.064 1.18898 14.665 1.43306 14.4189L4.04777 11.7824C4.05455 11.7752 4.06149 11.7683 4.06859 11.7614L11.2249 4.54553C11.2337 4.53607 11.2428 4.52684 11.2523 4.51787L13.6831 2.06687C13.9271 1.82076 14.3229 1.82076 14.5669 2.06687ZM11.513 6.03753L6.00913 11.5872H12.2329L12.2168 11.5368C11.9723 10.7604 11.75 9.47796 11.75 7.36483C11.7505 6.90971 11.6695 6.45977 11.513 6.03753Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M6.66162 13.3764C6.99352 13.2808 7.33944 13.4746 7.43425 13.8093C7.46937 13.9333 7.54358 14.0423 7.64565 14.12C7.74773 14.1976 7.8721 14.2396 7.99996 14.2396C8.12781 14.2396 8.25219 14.1976 8.35426 14.12C8.45633 14.0423 8.53054 13.9333 8.56566 13.8093C8.66047 13.4746 9.00639 13.2808 9.33829 13.3764C9.67019 13.472 9.8624 13.8208 9.76759 14.1555C9.65785 14.5428 9.42597 14.8836 9.10703 15.1262C8.78809 15.3688 8.39946 15.5 7.99996 15.5C7.60045 15.5 7.21182 15.3688 6.89288 15.1262C6.57395 14.8836 6.34206 14.5428 6.23233 14.1555C6.13752 13.8208 6.32972 13.472 6.66162 13.3764Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
